module.exports = __webpack_public_path__ + "img/feedback.94b81ff6.svg";